import { BaseApi } from './baseApi';
import { adaptListParams } from '../utils';
export default class ContactBookApi extends BaseApi {
    constructor() {
        super(...arguments);
        this.apiBasePath = 'contact-book';
    }
    listContactBook(params = {}) {
        return this.apiCall({
            method: 'GET',
            route: `${this.apiBasePath}`,
            params: Object.assign({}, adaptListParams(params)),
        });
    }
    getContactBook(id) {
        return this.apiCall({
            method: 'GET',
            route: `${this.apiBasePath}/${id}`,
        });
    }
    updateContactBook(id, data) {
        return this.apiCall({
            method: 'PATCH',
            route: `${this.apiBasePath}/${id}`,
            data,
        });
    }
    deleteContactBook(id, data = {}) {
        return this.apiCall({
            method: 'DELETE',
            route: `${this.apiBasePath}/${id}`,
            data,
        });
    }
    createContactBook(data) {
        return this.apiCall({
            method: 'POST',
            route: `${this.apiBasePath}`,
            data,
        });
    }
    shareContactBook(id, data) {
        return this.apiCall({
            method: 'POST',
            route: `${this.apiBasePath}/${id}/share`,
            data,
        });
    }
    restoreShareContactBook(id, shareMetaId) {
        return this.apiCall({
            method: 'POST',
            route: `${this.apiBasePath}/${id}/restore-share/${shareMetaId}`,
        });
    }
    getSharedBookMeta(id) {
        return this.apiCall({
            method: 'GET',
            route: `${this.apiBasePath}/${id}/shared-book-meta`,
        });
    }
    approveSharedBook(id) {
        return this.apiCall({
            method: 'POST',
            route: `${this.apiBasePath}/${id}/approve`,
        });
    }
    rejectShareBook(id, data) {
        return this.apiCall({
            method: 'POST',
            route: `${this.apiBasePath}/${id}/reject`,
            data,
        });
    }
}
//# sourceMappingURL=contactBookApi.js.map